var _rect, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCloseLarge = function SvgCloseLarge(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 24,
    height: 24,
    fill: "none"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "19.4,5.4 18.6,4.6 12,11.1 5.4,4.6 4.6,5.4 11.1,12 4.6,18.6 5.4,19.4 12,12.9 18.6,19.4 19.4,18.6  12.9,12 ",
    fill: "#8F95AB"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCloseLarge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CloseLarge.d2f4f769.svg";